import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appUppercase]',
})
export class UppercaseDirective {
  constructor(private el: ElementRef, private renderer: Renderer2, private control: NgControl) {}

  @HostListener('input', ['$event']) onInput(event: Event) {
    this.toUppercase();
  }

  private toUppercase() {
    const input = this.el.nativeElement as HTMLInputElement;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    const uppercasedValue = input.value.toUpperCase();

    // Actualiza el valor en el DOM
    this.renderer.setProperty(input, 'value', uppercasedValue);

    // Si el campo está vinculado a un FormControl, actualiza su valor
    if (this.control && this.control.control) {
      this.control.control.setValue(uppercasedValue, { emitEvent: false });
    }

    // Restaura la posición del cursor
    input.setSelectionRange(start, end);
  }
}